import React from "react";
import { Modal, Button } from "react-bootstrap";
import { Icon } from "@iconify/react";

const ConfirmationModal2 = ({ Confirmation, ConfirmationToggle, NextModal }) => {
  return (
    <>
      <Modal
        show={Confirmation}
        onHide={ConfirmationToggle}
        centered
        className="modal-getstarted modalnext rs-re-modal-soft-open"
      >
        <button type="button" className="rs-lc-close" onClick={ConfirmationToggle} aria-label="Close">
          <Icon icon="tabler:x" width={22} height={22} />
        </button>
        <Modal.Body className="text-center ConfirmationInfo rs-lc-body">
          <h3>Almost done…</h3>
          <p>
            Let&apos;s take five quick photos of your kitchen for a <b>&ldquo;Rapid Estimate&rdquo;</b>
          </p>
          <Button onClick={NextModal}>
            Next <span aria-hidden>→</span>
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ConfirmationModal2;
